import { UserManager, WebStorageStateStore } from "oidc-client-ts";
import { orendaOidcConfig } from "../../config/orendaOidcConfig";

// Cognito quirk: the cognito-idp issuer's OpenID discovery document publishes
// JWKS + userinfo but NOT authorization_endpoint / token_endpoint /
// end_session_endpoint (those live under the hosted-UI domain). We fetch the
// discovery doc for JWKS/issuer, then override the endpoints so sign-in /
// sign-out actually work.
const HOSTED_UI = "https://bopayments.auth.eu-west-1.amazoncognito.com";

// Singleton UserManager for the Cognito flow. Import this anywhere in the app
// that needs to trigger sign-in, read the current user, or sign out.
export const orendaUserManager = new UserManager({
  authority: orendaOidcConfig.authority,
  client_id: orendaOidcConfig.client_id,
  redirect_uri: orendaOidcConfig.redirect_uri,
  post_logout_redirect_uri: orendaOidcConfig.post_logout_redirect_uri,
  response_type: orendaOidcConfig.response_type,
  scope: orendaOidcConfig.scope,
  metadataUrl: orendaOidcConfig.metadataUrl,
  metadataSeed: {
    authorization_endpoint: `${HOSTED_UI}/oauth2/authorize`,
    token_endpoint: `${HOSTED_UI}/oauth2/token`,
    userinfo_endpoint: `${HOSTED_UI}/oauth2/userInfo`,
    end_session_endpoint: `${HOSTED_UI}/logout`,
    revocation_endpoint: `${HOSTED_UI}/oauth2/revoke`,
  },
  // Popup flow closes this page after the callback fires.
  popup_redirect_uri: orendaOidcConfig.redirect_uri,
  popup_post_logout_redirect_uri: orendaOidcConfig.post_logout_redirect_uri,
  // Cache tokens in sessionStorage (matches existing Card-Console pattern).
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  stateStore: new WebStorageStateStore({ store: window.sessionStorage }),
  automaticSilentRenew: orendaOidcConfig.automaticSilentRenew,
});
